import { render, staticRenderFns } from "./WeChatOrderList.vue?vue&type=template&id=146f6a12&scoped=true&"
import script from "./WeChatOrderList.vue?vue&type=script&lang=js&"
export * from "./WeChatOrderList.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=146f6a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f6a12",
  null
  
)

export default component.exports